/* eslint-disable import/no-default-export */
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IconName } from 'app/common/components/controls';
import { State, toggleBoardStar } from 'app/gamma/src/modules';

import { isBoardStarred } from 'app/gamma/src/selectors/boards';

import styles from './board-buttons.less';
import { BoardButton } from './button';

import { forTemplate } from 'app/common/lib/util/i18n';
const format = forTemplate('board_list_item');

interface OwnProps {
  readonly idBoard: string;
}

interface StateProps {
  readonly isStarred: boolean;
}

interface DispatchProps {
  onClick(): void;
}

interface AllProps extends OwnProps, StateProps, DispatchProps {}

class StarredBoardButton extends React.Component<AllProps> {
  onClickHandler: React.MouseEventHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.onClick();
  };

  render() {
    const { isStarred } = this.props;

    return (
      <BoardButton
        className={isStarred ? styles.yellowStar : ''}
        icon={IconName.Star}
        onClick={this.onClickHandler}
        tabIndex={-1}
        title={format(
          'click-to-star-this-board-it-will-show-up-at-top-of-your-boards-list',
        )}
      />
    );
  }
}

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
  const { idBoard } = ownProps;

  return {
    isStarred: isBoardStarred(state, idBoard),
  };
};

const mapDispatchToProps = (
  dispatch: Dispatch<State>,
  ownProps: OwnProps,
): DispatchProps => {
  const { idBoard } = ownProps;

  return {
    onClick() {
      /**
       * MS Edge has an issue with racing conditions in React, or
       * with the way async/await works, or both.
       * With optimistic updates happening here, it seems
       * that React is too fast to unbind callbacks, and Edge lets
       * the click go through a then unbound <a> on RouterLink.
       *
       * A setTimeout here fixes the problem.
       *
       * TODO: Remove this when EdgeHTML is not supported anymore
       */
      setTimeout(() => {
        dispatch(toggleBoardStar({ idBoard }));
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StarredBoardButton);
